module.exports = __webpack_public_path__ + "static/media/file_icon_1.0b8198d4.svg";